import { request } from './request'

export const getList = (data) => {
  const url = '/api/v1/collections'
  return request({
    method: 'get',
    url: url,
    params: data
  })
}

export const newOrModify = (data) => {
  const url = '/api/v1/collections/save'
  return request({
    method: 'post',
    url: url,
    data: data
  })
}

export const getDetail = (params) => {
  const url = '/api/v1/collections/getCollectionDetail'
  return request({
    method: 'get',
    url: url,
    params
  })
}

export const del = (id) => {
  const url = `/api/v1/collections/delete/${id}`
  return request({
    method: 'post',
    url: url,
  })
}

export const getProductsByConditions = (data) => {
  const url = '/api/v1/collections/conditions'
  return request({
    method: 'POST',
    url: url,
    data: data
  })
}

export const getCollectionBasicInfoByIds = (ids) => {
  const url = '/api/v1/collections/getCollectionBasicInfoByIds'
  return request({
    method: 'get',
    url: url,
    params: { ids }
  })
}
